import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import {
  Box,
  Button,
  Container,
  FormControl,
  Paper,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Typography,
  InputLabel,
  Grid,
} from "@mui/material";

import { Dashboard, Filter1, Filter2, Filter3, Search } from "@mui/icons-material";

import OverviewVendor from "./overviewVendor";
import IncomeAndExpenses from "./incomeAndExpenses";
import OverviewCompany from "./overviewCompany";
import DashboardOT from "./dashboard/ot/DashboardOT";
import DashboardWorkingTime from "./dashboard/workingTime/DashboardWorkingTime";
import DashboardCost from "./dashboard/cost/DashboardCost";

import {
  getAllCompanysByIdVendor,
  getCompanyBranch,
} from "../../../../actions/company";

import { getAllEmployeeByIdVendorAndIdCompany } from "../../../../actions/user";

import { getAllUsersVendor } from "../../../../actions/vendor";

import { getCompanyContract } from "../../../../actions/vendor";

import "dayjs/locale/th";
import OverviewPanel from "./overviewPanel";
import OvertimePanel from "./overtimePanel";
import WorkingtimePanel from "./workingTimePanel";
import CostPanel from "./costPanel";
import { getAllDepartments } from "../../../../actions/department";
import {
  getDashboardCost,
  getDashboardOvertime,
  getDashboardOverview,
  getDashboardWorkingtime,
} from "../../../../actions/dashboard";
import ExportButton from "../../shared/dashboard/export/ExportButton";
import { getEmployWorkingDays, getResignEmployee } from "../../../../actions/report";
import { getOvertime36HoursList } from "../../../../actions/requestTime";

let MockCompany = ["ไทยโพลิเอททีลีน", "กระทิงแดง", "โคคาโคล่า"];

const StyledRoot = styled("div")({
  backgroundColor: "#FFFFFF !important",
  "& .filter-container": {
    marginBottom: "24px",
    display: "flex",
    "& .filter-left": {
      flexGrow: "1",
      display: "flex",
      gap: "8px",
    },
    "& .filter-right": {
      display: "flex",
      gap: "8px",
    },
    "& .MuiInputBase-root": {
      minWidth: "150px",
      backgroundColor: "#ffffff",
      "& .MuiSelect-select": {
        "&:focus": {
          backgroundColor: "#ffffff",
        },
      },
    },
    "& .MuiInputLabel-root": {
      color: "#919eab",
    },
    "& .select-medium": {
      minWidth: "250px",
    },
  },
  "& .tabs-container": {
    marginBottom: "24px",
  },
});

const TabsStyled = styled(Tabs)({
  width: "fit-content",
  maxWidth: "100%",
  boxShadow:
    "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
  borderRadius: "16px",
  "& .tab": {
    backgroundColor: "#FFFFFF",
    height: "fit-content",
  },
  "& .TabBorderRight": {
    borderRight: "1px solid rgba(0,0,0,0.1)",
  },
  "& span": {
    display: "none",
  },
  "& .Mui-selected": {
    backgroundColor: "#007afe",
    color: "white !important",
    border: "1px solid #007afe",
  },
});

const Header = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: "20px",
});

const SelectCompany = styled(Select)(({ company }) => ({
  backgroundColor: "white",
  color: company === "" ? "darkgrey" : "initial",
  "& .MuiSelect-select": {
    height: "14px",
    paddingTop: "12px",
    paddingBottom: "12px",
  },
}));

const SelectMonth = styled(Select)(({ month }) => ({
  backgroundColor: "white",
  color: month === 12 ? "darkgrey" : "initial",
  "& .MuiSelect-select": {
    height: "14px",
    paddingTop: "12px",
    paddingBottom: "12px",
  },
}));

const Overview = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { result: AllCompanys } = useSelector((state) => state.companys);
  const { result: AllBranches } = useSelector((state) => state.companyBranch);
  const [company, setCompany] = useState("");
  const [month, setMonth] = useState(dayjs().get("month") + 1);
  const [year, setYear] = useState(dayjs().get("year"));
  const [branch, setBranch] = useState("all");

  const [department, setDepartment] = useState("");
  const [section, setSection] = useState("");
  const [tabValue, setTabValue] = useState("overviewVendor");
  const [applied, setApplied] = useState(null);
  const [companyDefaulted, setCompanyDefaulted] = useState(false);

  const fetchedKeyByTabRef = useRef({});
  const filterKey = (f) =>
    JSON.stringify({ c: f.company, d: f.department, s: f.section, m: f.month, y: f.year });

  const workdayQuery = (f, cid) => {
    const s = dayjs().year(Number(f.year)).month(Number(f.month) - 1).date(1);
    return {
      idCompany: cid,
      start: s.format("YYYY-MM-DD"),
      end: s.endOf("month").format("YYYY-MM-DD"),
      getAll: true,
    };
  };
  const workdayCompanyIds = (f) =>
    f.company ? [f.company] : (companyStore || []).map((c) => c.idCompany).filter(Boolean);

  const fetchTab = (tab, f) => {
    const base = {
      mode: "vendor",
      month: f.month,
      year: f.year,
      idCompany: f.company ? f.company : undefined,
      idDepartment: f.department ? f.department : undefined,
      idSection: f.section ? f.section : undefined,
    };
    if (tab === "overviewVendor" || tab === "incomeAndExpenses") {
      dispatch(getCompanyContract({ month: f.month, year: f.year }));
    } else if (tab === "dashboardOverview") {
      dispatch(getDashboardOverview(base));
      dispatch(getDashboardCost(base)); 
    } else if (tab === "dashboardOT") {
      dispatch(getDashboardOvertime(base));
      dispatch(getDashboardCost(base)); 
    } else if (tab === "dashboardWorkingTime") {
      dispatch(getDashboardWorkingtime(base));
    } else if (tab === "dashboardCost") {
      dispatch(getDashboardCost(base));
    }
    fetchedKeyByTabRef.current[tab] = filterKey(f);
  };

  const handleSearch = () => {
    const f = { company, department, section, month, year };
    setApplied(f);
    fetchTab(tabValue, f);
  };

  const handleChangeTab = (newTab) => {
    setTabValue(newTab);
    if (applied && fetchedKeyByTabRef.current[newTab] !== filterKey(applied)) {
      fetchTab(newTab, applied);
    }
  };

  const { result: dashboardOverview } = useSelector(
    (state) => state.dashboardOverview
  );
  const { result: dashboardOvertime } = useSelector(
    (state) => state.dashboardOvertime
  );
  const { result: dashboardWorkingtime } = useSelector(
    (state) => state.dashboardWorkingtime
  );
  const { result: dashboardCost } = useSelector((state) => state.dashboardCost);
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: departmentStore } = useSelector((state) => state.department);
  const { result: companyStore } = useSelector((state) => state.vendorContract);
 const vendorUsers = useSelector(function (state) {
    return state.users && state.users.result ? state.users.result : [];
  });

  const [leaveAbsentLate, setLeaveAbsentLate] = useState(null);
  const leaveKeyRef = useRef(null);

  useEffect(() => {
    dispatch(getCompanyContract({ month, year }));
    dispatch(getAllUsersVendor("all")); 
  }, []);

  const empPassesFilter = (e, f) => {
    if (!e) return false;
    if (f.company && String(e.idCompany) !== String(f.company)) return false;
    if (f.section && departmentStore) {
      let secName = null;
      departmentStore.forEach((d) =>
        (d.sections || []).forEach((s) => {
          if (String(s.idSection) === String(f.section)) secName = s.sectionName;
        })
      );
      if (secName && e.sectionName !== secName) return false;
    } else if (f.department && departmentStore) {
      const dep = departmentStore.find((d) => String(d.idDepartment) === String(f.department));
      const secNames = dep ? (dep.sections || []).map((s) => s.sectionName) : [];
      if (secNames.length && !secNames.includes(e.sectionName)) return false;
    }
    return true;
  };

  const activeEmpMap = React.useMemo(() => {
    const m = new Map();
    ((vendorUsers && vendorUsers.active) || []).forEach((e) => m.set(e.idEmp, e));
    return m;
  }, [vendorUsers]);

  const companiesWithActive = React.useMemo(() => {
    const s = new Set();
    ((vendorUsers && vendorUsers.active) || []).forEach((e) => s.add(String(e.idCompany)));
    return s;
  }, [vendorUsers]);
  const companyIdsToFetch = (f) =>
    f.company
      ? [f.company]
      : (companyStore || [])
          .map((c) => c.idCompany)
          .filter((cid) => companiesWithActive.has(String(cid)));

  const rosterAtMonthEnd = (f) => {
    if (!f || !vendorUsers) return [];
    const monthEnd = dayjs()
      .year(Number(f.year))
      .month(Number(f.month) - 1)
      .endOf("month");
    const roster = [
      ...(vendorUsers.active || []),
      ...((vendorUsers.termainate || vendorUsers.terminate) || []),
    ];
    const seen = new Set();
    return roster.filter((e) => {
      if (!e || seen.has(e.idEmp)) return false;
      if (!empPassesFilter(e, f)) return false;
      // ยังไม่เข้าทำงาน ณ สิ้นเดือนที่เลือก
      if (e.hiringDate && dayjs(e.hiringDate).isAfter(monthEnd, "day")) return false;
      // ลาออกไปก่อนสิ้นเดือนที่เลือก
      if (e.resignDate && dayjs(e.resignDate).isBefore(monthEnd, "day")) return false;
      seen.add(e.idEmp);
      return true;
    });
  };

  const computeRealEmployee = (f) => {
    if (!f || !vendorUsers) return null;
    let list = rosterAtMonthEnd(f);
    const male = list.filter((e) => e.gender === "ชาย").length;
    const female = list.filter((e) => e.gender === "หญิง").length;
    const salaryTotal = list.reduce((a, e) => {
      const v = Number(e.salaryValue) || 0;
      const isDaily = String(e.paymentTypeName || "").includes("วัน");
      return a + (isDaily ? v * 30 : v);
    }, 0);
    const newIn = list.filter(
      (e) =>
        e.hiringDate &&
        dayjs(e.hiringDate).month() + 1 === Number(f.month) &&
        dayjs(e.hiringDate).year() === Number(f.year)
    ).length;
    return {
      employeeTotal: list.length,
      maleTotal: male,
      femaleTotal: female,
      salaryTotal,
      employeeInTotal: newIn,
    };
  };

  const computeHeadcountByDept = (f) => {
    if (!f || !vendorUsers) return [];
    const m = {};
    rosterAtMonthEnd(f).forEach((e) => {
      const k = e.sectionName || "ไม่ระบุ";
      m[k] = (m[k] || 0) + 1;
    });
    return Object.keys(m)
      .map((name) => ({ name, count: m[name] }))
      .sort((a, b) => b.count - a.count);
  };

  const computeHeadcountTrend = (f) => {
    if (!f || !vendorUsers) return [];
    const now = dayjs();
    const isCurrentYear = Number(f.year) === now.year();
    const maxMonth = isCurrentYear ? now.month() + 1 : 12;
    const out = [];
    for (let m = 1; m <= maxMonth; m++) {
      // ใช้กติกาเดียวกับการ์ดพนักงาน → จุดของเดือนที่เลือกจะตรงกับการ์ดเสมอ
      out.push({
        x: dayjs().month(m - 1).format("MMM"),
        y: rosterAtMonthEnd({ ...f, month: m }).length,
      });
    }
    return out;
  };

  const sumLeaveUsed = (lu) =>
    lu && typeof lu === "object"
      ? Object.values(lu).reduce((a, v) => a + (Number(v) || 0), 0)
      : 0;

  const computeRealWorkingTime = (f) => {
    if (!f || !leaveAbsentLate || !leaveAbsentLate.employeeList || !vendorUsers) return null;
    const wdMap = new Map();
    leaveAbsentLate.employeeList.forEach((e) => wdMap.set(e.idEmp, e));
    const rows = (vendorUsers.active || [])
      .filter((emp) => empPassesFilter(emp, f))
      .map((emp) => {
        const wd = wdMap.get(emp.idEmp) || {};
        return {
          idEmp: emp.idEmp,
          firstname: emp.firstname,
          lastname: emp.lastname,
          imageProfile: emp.imageProfile || null,
          arrive: Number(wd.arrive) || 0,
          absent: Number(wd.absent) || 0,
          late: Number(wd.late) || 0,
          earlyBack: Number(wd.earlyBack) || 0,
          leave: sumLeaveUsed(wd.leaveUsed),
        };
      });
    return {
      absentTotal: rows.reduce((a, r) => a + r.absent, 0),
      lateTotal: rows.reduce((a, r) => a + r.late, 0),
      earlyTotal: rows.reduce((a, r) => a + r.earlyBack, 0),
      leaveTotal: rows.reduce((a, r) => a + r.leave, 0),
      top5Absent: rows.filter((r) => r.absent > 0).sort((a, b) => b.absent - a.absent).slice(0, 5),
      top5Late: rows.filter((r) => r.late > 0).sort((a, b) => b.late - a.late).slice(0, 5),
      rows,
    };
  };

  const computeWorkdayRows = (f) => {
    const rwt = computeRealWorkingTime(f);
    if (!rwt) return null;
    return rwt.rows
      .slice()
      .sort((a, b) => b.absent + b.late + b.earlyBack + b.leave - (a.absent + a.late + a.earlyBack + a.leave));
  };

  const computeWorkdayTop5Absent = (f) => {
    const rwt = computeRealWorkingTime(f);
    if (!rwt) return null;
    return rwt.top5Absent.map((r) => ({ ...r, absentTotal: r.absent }));
  };

  const computeLeaveByType = (f) => {
    if (!leaveAbsentLate || !leaveAbsentLate.employeeList) return [];
    const nameMap = {};
    (leaveAbsentLate.leaveList || []).forEach((l) => {
      nameMap[l.idLeaveGroup] = l.leaveGroupName;
    });
    const agg = {};
    leaveAbsentLate.employeeList
      .filter((e) => activeEmpMap.has(e.idEmp))
      .filter((e) => empPassesFilter(activeEmpMap.get(e.idEmp), f))
      .forEach((e) => {
        const lu = e.leaveUsed || {};
        Object.keys(lu).forEach((gid) => {
          agg[gid] = (agg[gid] || 0) + (Number(lu[gid]) || 0);
        });
      });
    return Object.keys(agg)
      .filter((gid) => agg[gid] > 0)
      .map((gid) => ({ name: nameMap[gid] || "อื่นๆ", value: agg[gid] }))
      .sort((a, b) => b.value - a.value);
  };

  const weeksOfMonth = (m, y) => {
    const first = dayjs().year(y).month(m - 1).date(1);
    const last = first.endOf("month");
    let cur = first.startOf("week"); 
    cur = cur.day() === 0 ? cur.add(1, "day") : cur.startOf("week").add(1, "day");
    const weeks = [];
    let guard = 0;
    while (cur.isBefore(last) && guard++ < 8) {
      const end = cur.add(6, "day");
      weeks.push({
        start: cur.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
        label: `${cur.format("D MMM")} - ${end.format("D MMM")}`,
      });
      cur = cur.add(7, "day");
    }
    return weeks;
  };

  const fetchOT36List = async (f) => {
    const companyIds = companyIdsToFetch(f); // ข้ามบริษัทว่าง
    const weeks = weeksOfMonth(f.month, f.year);
    const pairs = [];
    weeks.forEach((w, wi) => companyIds.forEach((cid) => pairs.push({ wi, w, cid })));
    const results = await mapLimit(pairs, 4, (p) =>
      getOvertime36HoursList({ idCompany: p.cid, start: p.w.start, end: p.w.end })
        .then((r) => ({ wi: p.wi, list: Array.isArray(r) ? r : [] }))
        .catch(() => ({ wi: p.wi, list: [] }))
    );
    return weeks.map((w, wi) => ({
      ...w,
      employees: results
        .filter((r) => r.wi === wi)
        .flatMap((r) => r.list)
        .filter((x) => x && Number(x.amountHours) > 36 && activeEmpMap.has(x.idEmp)) // "เกิน 36" = มากกว่า 36 (ไม่นับ 36.00 พอดี) + ตัดลาออก
        .filter((x) => empPassesFilter(activeEmpMap.get(x.idEmp), f))
        .map((x) => {
          const emp = activeEmpMap.get(x.idEmp) || {};
          return { ...x, imageProfile: emp.imageProfile, employeeId: x.employeeId || emp.employeeId || emp.employeeTypeEmployeeId };
        }),
    }));
  };

  const mapLimit = async (items, limit, fn) => {
    const ret = [];
    let i = 0;
    const workers = Array.from({ length: Math.min(limit, items.length || 1) }, async () => {
      while (i < items.length) {
        const idx = i++;
        ret[idx] = await fn(items[idx], idx);
      }
    });
    await Promise.all(workers);
    return ret;
  };

  const [resignList, setResignList] = useState(null);
  const resignKeyRef = useRef(null);
  useEffect(() => {
    if (tabValue !== "dashboardOverview" || !applied) return;
    const f = applied;
    const key = JSON.stringify({ c: f.company, d: f.department, s: f.section, m: f.month, y: f.year });
    if (resignKeyRef.current === key) return;
    resignKeyRef.current = key;
    const ym = `${f.year}-${String(f.month).padStart(2, "0")}`;
    let cancelled = false;
    setResignList(null);
    const imgMap = {};
    [
      ...((vendorUsers && vendorUsers.active) || []),
      ...((vendorUsers && (vendorUsers.termainate || vendorUsers.terminate)) || []),
    ].forEach((e) => {
      if (e.employeeId && e.imageProfile) imgMap[e.employeeId] = e.imageProfile;
    });
    (async () => {
      try {
        const q = f.company
          ? { idCompany: f.company, month: ym, year: String(f.year) }
          : { month: ym, year: String(f.year) };
        const rs = await getResignEmployee(q);
        const items = (rs && Array.isArray(rs.data) ? rs.data : [])
          .filter(
            (x) =>
              (!f.section || String(x.idSection) === String(f.section)) &&
              (!f.department || String(x.idDepartment) === String(f.department))
          )
          .map((e) => ({
            firstname: e.firstname,
            lastname: e.lastname,
            positionName: e.positionsName,
            imageProfile: e.imageProfile || imgMap[e.employeeId] || null,
            dateText: e.resignDate ? dayjs(e.resignDate).locale(localStorage.getItem("language") || "th").format(localStorage.getItem("language") === "en" ? "D MMMM YYYY" : "D MMMM BBBB") : "",
          }));
        if (!cancelled) setResignList(items);
      } catch (e) {
        if (!cancelled) setResignList([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [tabValue, applied]);

  useEffect(() => {
    const onTab = tabValue === "dashboardOverview" || tabValue === "dashboardWorkingTime";
    if (!onTab || !applied || !companyStore) return;
    const f = applied;
    const companyIds = workdayCompanyIds(f);
    if (!companyIds.length) return;
    const key = JSON.stringify({ m: f.month, y: f.year, c: companyIds });
    if (leaveKeyRef.current === key) return;
    leaveKeyRef.current = key;
    let cancelled = false;
    setLeaveAbsentLate(null);
    (async () => {
      try {
        const results = await mapLimit(companyIds, 3, (cid) =>
          getEmployWorkingDays(workdayQuery(f, cid))
            .then((r) => (r && r.data ? r.data : null))
            .catch(() => null)
        );
        let employeeList = [];
        const leaveList = [];
        const seen = new Set();
        results.filter(Boolean).forEach((d) => {
          if (d.employeeList) employeeList = employeeList.concat(d.employeeList);
          (d.leaveList || []).forEach((l) => {
            if (!seen.has(l.idLeaveGroup)) {
              seen.add(l.idLeaveGroup);
              leaveList.push(l);
            }
          });
        });
        if (!cancelled) setLeaveAbsentLate({ employeeList, leaveList });
      } catch (e) {
        if (!cancelled) setLeaveAbsentLate(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [tabValue, applied, companyStore]);


  const computeNewEmployees = (f) => {
    if (!f || !vendorUsers) return null;
    return rosterAtMonthEnd(f)
      .filter(
        (e) =>
          e.hiringDate &&
          dayjs(e.hiringDate).month() + 1 === Number(f.month) &&
          dayjs(e.hiringDate).year() === Number(f.year)
      )
      .map((e) => ({
        firstname: e.firstname,
        lastname: e.lastname,
        positionName: e.positionsName,
        imageProfile: e.imageProfile || null,
        dateText: dayjs(e.hiringDate).format("D MMMM YYYY"),
      }));
  };

  useEffect(() => {
    if (company) {
      dispatch(getAllDepartments({ idCompany: company }));
    }
  }, [company]);

  useEffect(() => {
    if (!companyDefaulted && companyStore && companyStore.length > 0) {
      setCompany(companyStore[0].idCompany);
      setCompanyDefaulted(true);
    }
  }, [companyStore, companyDefaulted]);

  const contentRef = useRef(null);
  const tabLabels = {
    overviewVendor: t("CustomerOverview"),
    incomeAndExpenses: `${t("Income")}-${t("Expense")}`,
    dashboardOverview: t("Overview"),
    dashboardOT: t("Overtime"),
    dashboardWorkingTime: t("WorkTimeOverview"),
    dashboardCost: t("CostOverview"),
  };

  const appliedCompanyName =
    applied && applied.company
      ? ((companyStore || []).find((c) => c.idCompany === applied.company) || {})
          .companyName || t("All")
      : t("All");
  const appliedMonthText = applied
    ? dayjs().month(applied.month - 1).format("MMMM")
    : "";
  const appliedYearBE = applied ? applied.year + 543 : "";
  const exportFileName = applied
    ? `${tabLabels[tabValue]}_${appliedCompanyName}_${appliedMonthText}_${appliedYearBE}`
    : tabLabels[tabValue];

  const tabDataLoaded = {
    overviewVendor: true, 
    incomeAndExpenses: true,
    dashboardOverview: !!dashboardOverview,
    dashboardOT: !!dashboardOvertime,
    dashboardWorkingTime: !!dashboardWorkingtime,
    dashboardCost: !!dashboardCost,
  };
  const currentTabLoaded = !!applied && !!tabDataLoaded[tabValue];

  const cd = dashboardCost && dashboardCost.costData;
  const realCostData =
    cd && (cd.totalSalary || cd.totalOT || cd.totalNet) ? cd : null;
  const empLoading = !(vendorUsers && vendorUsers.active);
  const costLoading = !dashboardCost;

  return (
    <StyledRoot className="page">
      <Container
        maxWidth="lg"
        style={{
          marginTop: "20px",
          height: "fit-content",
          minHeight: "calc(100vh - 100px)",
          paddingBottom: "40px",
        }}
      >
        <Paper
          elevation={2}
          style={{ padding: "16px", marginBottom: "24px", borderRadius: "16px" }}
        >
        <Grid container spacing={2} alignItems="flex-start">
          {/* แถวบน: ปี + เดือน ชิดขวา */}
          <Grid item xs={12} container spacing={2} justifyContent="flex-end">
            <Grid item xs={6} sm={3}>
              <FormControl variant="filled" fullWidth>
                <InputLabel>{t("Year")}</InputLabel>
                <Select
                  label={`${t("Year")}`}
                  displayEmpty
                  disableUnderline
                  value={year}
                  onChange={(event) => {
                    if (
                      dayjs()
                        .set("month", month - 1)
                        .set("year", parseInt(event.target.value))
                        .isBefore(dayjs().set("month", 1).set("year", 2023))
                    ) {
                      setMonth(2);
                    } else if (
                      dayjs()
                        .set("month", month - 1)
                        .set("year", parseInt(event.target.value))
                        .isAfter(dayjs())
                    ) {
                      setMonth(dayjs().get("month") + 1);
                    }
                    setYear(event.target.value);
                  }}
                >
                  {[...Array(dayjs().format("YYYY") - 2023 + 1)].map(
                    (_, index) => (
                      <MenuItem
                        key={index}
                        value={Number(
                          dayjs().subtract(index, "year").format("YYYY")
                        )}
                      >
                        {parseInt(dayjs().format("YYYY")) - index}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControl variant="filled" fullWidth>
                <InputLabel>{t("Month")}</InputLabel>
                <Select
                  label={`${t("Month")}`}
                  displayEmpty
                  disableUnderline
                  value={month}
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                >
                  {[...Array(12)].map((_, index) => {
                    if (
                      dayjs()
                        .set("month", index)
                        .set("year", year)
                        .isSameOrAfter(
                          dayjs().set("month", 1).set("year", 2023)
                        ) &&
                      !dayjs()
                        .set("month", index)
                        .set("year", year)
                        .isAfter(dayjs())
                    ) {
                      return (
                        <MenuItem key={index} value={index + 1}>
                          {dayjs().month(index).format("MMMM")}
                        </MenuItem>
                      );
                    }
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* บริษัท เต็มแถว */}
          <Grid item xs={12}>
            <FormControl variant="filled" fullWidth>
              <InputLabel shrink>{t("Company")}</InputLabel>
              <Select
                fullWidth
                label={`${t("Company")}`}
                displayEmpty
                disableUnderline
                value={company}
                onChange={(e) => {
                  setCompany(e.target.value);
                  setDepartment("");
                  setSection("");
                }}
              >
                <MenuItem value={""}>{t("All")}</MenuItem>
                {companyStore &&
                  companyStore.map((c) => (
                    <MenuItem key={c.idCompany} value={c.idCompany}>
                      {c.companyName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          {/* แผนก (โหลดจากบริษัท) + ส่วน (ของแผนกที่เลือก) */}
          <Grid item xs={12} sm={6}>
            <FormControl variant="filled" fullWidth>
              <InputLabel shrink>{t("Section")}</InputLabel>
              <Select
                label={`${t("Section")}`}
                displayEmpty
                disableUnderline
                value={department}
                onChange={(e) => {
                  setDepartment(e.target.value);
                  setSection("");
                }}
              >
                <MenuItem value={""}>{t("All")}</MenuItem>
                {departmentStore &&
                  departmentStore.map((d) => (
                    <MenuItem key={d.idDepartment} value={d.idDepartment}>
                      {d.departmentName}{" "}
                      {d.divisionName ? `(${d.divisionName})` : null}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="filled" fullWidth>
              <InputLabel shrink>{t("Department")}</InputLabel>
              <Select
                label={`${t("Department")}`}
                notched
                displayEmpty
                disableUnderline
                value={section}
                onChange={(e) => {
                  setSection(e.target.value);
                }}
              >
                <MenuItem value={""}>{t("All")}</MenuItem>
                {departmentStore &&
                  department &&
                  (
                    (departmentStore.find((d) => d.idDepartment === department) ||
                      {}).sections || []
                  ).map((s) => (
                    <MenuItem key={s.idSection} value={s.idSection}>
                      {s.sectionName}{" "}
                      {s.sectionName ? `(${s.sectionName})` : null}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          {/* ปุ่มค้นหา ชิดขวาล่าง */}
          <Grid item xs={12} container justifyContent="flex-end">
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={handleSearch}
              sx={{
                borderRadius: "8px",
                px: 4,
                backgroundColor: "#007afe",
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              {t("Search")}
            </Button>
          </Grid>
        </Grid>
        </Paper>

        <Box className="tabs-container">
          <TabsStyled
            value={tabValue}
            onChange={(event, newValue) => handleChangeTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab
              className="tab TabBorderRigth"
              icon={<Dashboard />}
              iconPosition="start"
              label={`${t("CustomerOverview")}`}
              value="overviewVendor"
            />
            <Tab
              className="tab TabBorderRigth"
              icon={<Dashboard />}
              iconPosition="start"
              label={`${t("Income")}-${t("Expense")}`}
              value="incomeAndExpenses"
            />
            <Tab
              className="tab TabBorderRight"
              icon={<Dashboard />}
              iconPosition="start"
              label={`${t("Overview")}`}
              value="dashboardOverview"
            />
            <Tab
              className="tab TabBorderRight"
              icon={<Filter1 />}
              iconPosition="start"
              label={`${t("Overtime")}`}
              value="dashboardOT"
            />
            <Tab
              className="tab TabBorderRight"
              icon={<Filter2 />}
              iconPosition="start"
              label={`${t("WorkTimeOverview")}`}
              value="dashboardWorkingTime"
            />
            <Tab
              className="tab"
              icon={<Filter3 />}
              iconPosition="start"
              label={`${t("CostOverview")}`}
              value="dashboardCost"
            />
          </TabsStyled>
        </Box>

        {!applied && (
          <Box>
            <Typography textAlign="center" color="text.secondary">
              {t("PleaseSearchData")}
            </Typography>
          </Box>
        )}

        {applied && (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1.5,
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography color="text.secondary" sx={{ fontSize: 14 }}>
              {t("Company")}: <b>{appliedCompanyName}</b> &nbsp;|&nbsp;{" "}
              {t("Month")}: <b>{appliedMonthText}</b> &nbsp;|&nbsp; {t("Year")}:{" "}
              <b>{appliedYearBE}</b>
            </Typography>
            {tabValue !== "overviewVendor" && currentTabLoaded && (
              <ExportButton
                getElement={() => contentRef.current}
                fileName={exportFileName}
                title={tabLabels[tabValue]}
                subtitle={`${t("Company")}: ${appliedCompanyName}  |  ${t(
                  "Month"
                )}: ${appliedMonthText}  |  ${t("Year")}: ${appliedYearBE}`}
              />
            )}
          </Box>
        )}

        <Box ref={contentRef}>
        {applied && tabValue === "overviewVendor" && (
          <OverviewVendor company={applied.company} />
        )}
        {applied && tabValue === "incomeAndExpenses" && (
          <IncomeAndExpenses
            year={applied.year}
            company={applied.company}
          />
        )}

        {applied && tabValue === "dashboardOverview" && (
          <Box>
            {dashboardOverview ? (
              <OverviewPanel
                month={applied.month}
                year={applied.year}
                realEmployee={computeRealEmployee(applied)}
                realCost={realCostData}
                realOT={realCostData ? realCostData.totalOT : null}
                realWorkingTime={computeRealWorkingTime(applied)}
                workdayRows={computeWorkdayRows(applied)}
                top5LeaveAbsent={computeWorkdayTop5Absent(applied)}
                resignList={resignList}
                newEmployees={computeNewEmployees(applied)}
                fetchOT36={() => fetchOT36List(applied)}
                activeEmpMap={activeEmpMap}
                headcountTrend={computeHeadcountTrend(applied)}
                empLoading={empLoading}
                costLoading={costLoading}
              />
            ) : (
              <Typography textAlign="center">{t("LoadingData")}...</Typography>
            )}
          </Box>
        )}

        {applied && tabValue === "dashboardOT" && (
          <Box>
            {dashboardOvertime ? (
              <OvertimePanel
                month={applied.month}
                year={applied.year}
                realEmployee={computeRealEmployee(applied)}
                realCost={realCostData}
                realOT={realCostData ? realCostData.totalOT : null}
                fetchOT36={() => fetchOT36List(applied)}
                activeEmpMap={activeEmpMap}
                headcountByDept={computeHeadcountByDept(applied)}
                empLoading={empLoading}
                costLoading={costLoading}
              />
            ) : (
              <Typography textAlign="center">{t("LoadingData")}...</Typography>
            )}
          </Box>
        )}

        {applied &&
          tabValue === "dashboardWorkingTime" && (
            <Box>
              {dashboardWorkingtime ? (
                <WorkingtimePanel
                  month={applied.month}
                  year={applied.year}
                  realEmployee={computeRealEmployee(applied)}
                  realWorkingTime={computeRealWorkingTime(applied)}
                  leaveByType={computeLeaveByType(applied)}
                  empLoading={empLoading}
                />
              ) : (
                <Typography textAlign="center">
                  {t("LoadingData")}...
                </Typography>
              )}
            </Box>
          )}

        {applied && tabValue === "dashboardCost" && (
          <Box>
            {dashboardCost ? (
              <CostPanel
                month={applied.month}
                year={applied.year}
                realEmployee={computeRealEmployee(applied)}
                realOT={realCostData ? realCostData.totalOT : null}
                empLoading={empLoading}
              />
            ) : (
              <Typography textAlign="center">{t("LoadingData")}...</Typography>
            )}
          </Box>
        )}
        </Box>
      </Container>
    </StyledRoot>
  );
};

export default Overview;
